import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./NavMenuItem.css";
import { useState, useRef, useEffect } from "react";

/*
const navitem = {
  title: "Previous Years",
  items: [
    { title: "SmartComp 2024", url: "https://smartcomp.w.waseda.jp/" },
    { title: "SmartComp 2023", url: "https://smartcomp.isis.vanderbilt.edu/" },
    { title: "SmartComp 2022", url: "https://smartcomp.aalto.fi/" },
    { title: "SmartComp 2021", url: "https://smartcomp2021.weebly.com/" },
    {
      title: "SmartComp 2020",
      url: "https://smartcomp2020.weebly.com/home.html",
    },
  ],
};
*/

export default function NavMenuItem(props) {
  const navitem = props.props;
  console.log(props);
  const [menuOpen, setMenuOpen] = useState(false);
  const catMenu = useRef(null);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const closeOpenMenus = (e) => {
    if (menuOpen && !catMenu.current?.contains(e.target)) {
      setMenuOpen(false);
    }
  };

  document.addEventListener("mousedown", closeOpenMenus);

  return (
    <>
      <ul className="navmenu">
        <li className="navmenutitle">
          <button
            className="navbutton"
            onClick={() => {
              setMenuOpen(!menuOpen);
            }}
          >
            {navitem.title}
          </button>
          <nav>
            <ul className="navlist" id={menuOpen ? "navmenu-open" : ""}>
              {navitem.items.map(function (data) {
                return (
                  <li>
                    <NavLink to={data.url}>{data.title}</NavLink>
                  </li>
                );
              })}
            </ul>
          </nav>
        </li>
      </ul>
    </>
  );
}
